import { render, staticRenderFns } from "./PurchaseWaiter.vue?vue&type=template&id=d149ebb4"
import script from "./PurchaseWaiter.vue?vue&type=script&lang=js"
export * from "./PurchaseWaiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports